import gql from "graphql-tag"

const CREATE_OR_UPDATE_CART_RULE = gql`
  mutation createOrUpdateDiscountRule(
    $id: ID!
    $input: InputCreateOrUpdateDiscountRule!
  ) {
    createOrUpdateDiscountRule(
      id: $id
      discountRule: $input
    ) {
      id
    }
  }
`

export default CREATE_OR_UPDATE_CART_RULE
